export default __webpack_public_path__ + "static/media/messageAlert32.81b34645.svg";